import { IGenericJSON } from '../helpers/interface';
import { User } from './user';
/** Event details a draft post holds until it's published. `day` is YYYY-MM-DD. */
export interface DraftEvent {
  title?: string;
  day?: string;
  start_time?: string;
  end_time?: string;
  place?: string;
  description?: string;
}

/** A shared event linked to a post, as shown on the post. */
export interface LinkedEvent {
  id: number;
  title: string;
  day: string;
  start_time: string;
}

export class Post {
  id: number;
  user_id: number;
  content: string;
  date: Date;
  user: User | null;
  commentCount: number;
  /** 'draft', 'posted', 'edited', 'deleted', 'reported', or null for a never-touched post. */
  status: string | null;
  postGrades: number[];
  postCareers: number[];
  postInterests: number[];
  postGroups: number[];
  postGroupNames: string[];
  /** IDs of the events linked to this post. */
  postEvents: number[];
  /** The events linked to this post, shown on it with a link to the calendar. */
  linkedEvents: LinkedEvent[];
  /** "Also create an event" details saved with a draft; null once published. */
  draftEvent: DraftEvent | null;

  constructor(data: IGenericJSON) {
    this.id = data['id'];
    this.user_id = data['user_id'];
    this.content = data['content'];
    this.date = new Date(data['createdAt']);
    this.user = data['User'] ? User.digest(data['User']) : null;
    this.status = data['status'] ?? null;
    this.commentCount = data['comment_count'];
    this.postGrades = (data['PostGrades'] ?? []).map((pg: any) => pg.grade_level);
    this.postCareers = (data['Careers'] ?? []).map((c: any) => c.id);
    this.postInterests = (data['Interests'] ?? []).map((i: any) => i.id);
    this.postGroups = (data['Groups'] ?? []).map((i: any) => i.id);
    this.postGroupNames = (data['Groups'] ?? []).map((g: any) => g.name);
    this.linkedEvents = (data['Events'] ?? []).map((e: any) => ({
      id: e.id,
      title: e.title,
      day: e.day,
      start_time: e.start_time,
    }));
    this.postEvents = this.linkedEvents.map((e) => e.id);
    this.draftEvent = data['draft_event'] ?? null;
  }

  public static digest(data: IGenericJSON): Post {
    return new Post(data);
  }

  public static digestResponse(data: IGenericJSON[]): Post[] {
    return data.map((u: IGenericJSON) => this.digest(u));
  }
}
